import { SegmentedControl } from '../SegmentedControl';
import { RANGE_KEYS, type RangeKey } from './useChartRange';

interface Props {
  value: RangeKey;
  onChange: (key: RangeKey) => void;
}

// Segmented 1d/3d/7d/30d control for a chart card header. Preset buttons
// rather than drag-to-zoom: one tap on a phone, and they map straight onto
// the history fetch.
export function RangeSelector({ value, onChange }: Props) {
  return <SegmentedControl options={RANGE_KEYS} value={value} onChange={onChange} label="Time range" />;
}
